<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">Dashboard</h2>
        </template>

        <div class="mb-12">
            <h2 v-if="hasIncidents" class="mb-8 text-xl font-medium">{{ $t("dashboard.recent_title") }}</h2>

            <div v-if="!hasIncidents" class="max-w-7xl mx-auto">
                <div class="w-full m-auto justify-center items-center">
                    <div class="flex">
                        <fa-icon icon="smile-wink" class="mx-auto text-7xl text-gray-300"></fa-icon>
                    </div>
                    <h2 class="my-2 text-4xl text-gray-300 text-center">
                        {{ $t("dashboard.no_recent_incidents") }}
                    </h2>
                </div>
            </div>

            <div v-if="hasIncidents" class="max-w-7xl">
                <incident
                    v-for="incident in incidents.data"
                    :key="incident.id"
                    :incident="incident"
                    :tenant="$attrs.tenant"
                    class="w-full max-w-2xl mb-5"
                ></incident>

                <div v-if="!incidents.links.prev && !incidents.links.next" class=""></div>
                <pagination
                    v-else
                    class="w-full"
                    :pages="paginate"
                    :previous-page-url="incidents.links.prev"
                    :next-page-url="incidents.links.next"
                ></pagination>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import Pagination from "@/Components/Pagination";
import Incident from "@/Components/Incident";
import FaIcon from "@/Components/FaIcon";
import { computed } from "vue";
import getPages from "@/Composables/Pagination";

export default {
    components: {
        FaIcon,
        AppLayout,
        Pagination,
        Incident,
    },
    props: {
        incidents: {
            type: Object,
        },
    },
    setup(props) {
        const hasIncidents = computed(() => Boolean(props.incidents.data.length));

        const paginate = computed(() => {
            const { load, pages } = getPages();
            load(props.incidents);
            return pages.value;
        });

        return {
            paginate,
            hasIncidents,
        };
    },
};
</script>
